import {Component, OnInit} from '@angular/core';
import {FormComponent, RequestParams} from '@ngx-ivengi/crud';
import {UIRouter} from '@uirouter/angular';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {Device} from './device.model';
import {DeviceService} from './device.service';
import {User} from '../user/user.model';
import {UserService} from '../user/user.service';

@Component({
  selector: 'app-device-form',
  templateUrl: './device-form.component.html'
})
export class DeviceFormComponent extends FormComponent implements OnInit {

  public device: Device = new Device();
  public users: User[] = [];
  public formTitle: string;
  public stateIdParam: string = 'deviceId';

  constructor(
    protected router: UIRouter,
    private deviceService: DeviceService,
    private userService: UserService,
    private translate: TranslateService
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    const requestParams = new RequestParams();
    requestParams
      .addFilterParam({
        id: 0,
        key: 'roles',
        operator: 'eq',
        value: 'MECHANIC',
        filterFn: 'substringof',
        filterOutcome: 'true'
      })
      .pagination.limit = 0;
    this.userService.getAll(requestParams).subscribe((users: User[]) => {
      this.users = users;
    });

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('device.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE: {
        this.deviceService.get(this.router.stateService.params[this.stateIdParam]).subscribe((device) => {
          this.device = device;
        });

        this.translate.get('device.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;
    }
  }

  public save(): void {
    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.deviceService.add(this.device).subscribe((result) => {
          this.router.stateService.go('management.device', this.router.stateService.params, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE: {
        this.deviceService.update(this.device).subscribe((result) => {
          this.router.stateService.go('management.device', this.router.stateService.params, {reload: true});
        });
      } break;
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/device/device-form.component.ts